import PersonContainer from 'UI/views/Person';
import PersonPageContainer from 'UI/views/PersonPage';
import { wrapper } from 'redux/store';
import { getInitialPersonProps } from 'utils/personUtils';

const Person = ({
  isNewPerson,
  ...rest
}) => (isNewPerson
  ? (
    <PersonPageContainer
      {...rest}
    />
  )
  : (
    <PersonContainer
      {...rest}
    />
  ));

export const getStaticPaths = async () => ({
  paths: [],
  fallback: 'blocking',
});

export const getStaticProps = wrapper.getStaticProps(
  (store) => async (ctx) => getInitialPersonProps(store, ctx),
);

export default Person;
